import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles

import "swiper/swiper.min.css";
import "swiper/components/effect-fade/effect-fade.min.css";
import "swiper/components/navigation/navigation.min.css";
import "swiper/components/pagination/pagination.min.css";
// import Swiper core and required modules
import SwiperCore, { EffectFade, Navigation, Pagination } from "swiper/core";
import whatsnews from "views/whats-new/img/whatsnew.png";
// install Swiper modules
SwiperCore.use([EffectFade, Navigation, Pagination]);

export default function App() {
  return (
    <>
      <div className="lg:px-0 md:px-0 px-5">
        <Swiper
          spaceBetween={30}
          effect={"fade"}
          navigation={false}
          pagination={{
            clickable: true,
          }}
          className="mySwiper "
        >
          <SwiperSlide className="relative ">
            <img
              src={whatsnews}
              className="w-full maxh-396px object-fill xs-h198"
              alt="banner-img "
            />

            <div className="inside-listing absolute lg:w-1/3 md:w-1/3 w-1/2 text-left">
              <h1 className="text-black font-semibold sm-fsize16">
                What’s New
              </h1>
              <p className="text262626 fsize18 text-left sm-fsize12">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                accusantium doloremque laudantium
              </p>
            </div>
          </SwiperSlide>

          <SwiperSlide className="relative ">
            <img
              src={whatsnews}
              className="w-full maxh-396px object-fill xs-h198"
              alt="banner-img "
            />

            <div className="inside-listing absolute lg:w-1/3 md:w-1/3 w-1/2 text-left">
              <h1 className="text-black font-semibold sm-fsize16">
                What’s New
              </h1>
              <p className="text262626 fsize18 text-left sm-fsize12">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                accusantium doloremque laudantium
              </p>
            </div>
          </SwiperSlide>

          <SwiperSlide className="relative ">
            <img
              src={whatsnews}
              className="w-full maxh-396px object-fill xs-h198"
              alt="banner-img "
            />

            <div className="inside-listing absolute lg:w-1/3 md:w-1/3 w-1/2 text-left">
              <h1 className="text-black font-semibold sm-fsize16">
                What’s New
              </h1>
              <p className="text262626 fsize18 text-left sm-fsize12">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                accusantium doloremque laudantium
              </p>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </>
  );
}
